import { computed, onMounted, onUnmounted, ref } from "vue";

/**
 * A lightweight Vue composable that provides reactive access to the current browser location.
 * It listens for the native `popstate` event (browser Back/Forward buttons) to update the state.
 *
 * @returns An object containing the reactive URL path and parsed query parameters.
 */
export function useRoute() {
  const path = ref(globalThis.location.pathname);
  const search = ref(globalThis.location.search);

  function onPopState() {
    path.value = globalThis.location.pathname;
    search.value = globalThis.location.search;
  }

  onMounted(() => globalThis.addEventListener("popstate", onPopState));
  onUnmounted(() => globalThis.removeEventListener("popstate", onPopState));

  const query = computed(() => {
    const params = new URLSearchParams(search.value);
    return [...params].reduce(
      (acc, [key, value]) => {
        acc[key] = value;
        return acc;
      },
      {} as Record<string, string>,
    );
  });

  return { path, query };
}
